// extracted by mini-css-extract-plugin
export default {"modalBox":"style_modalBox__YK4N4","drawerBox":"style_drawerBox__BUnHj","restrictionTitle":"style_restrictionTitle__P7vsw","restrictionText":"style_restrictionText__m8uFg"};